export const menuTitle = { title: "COMPARATION", label: "Comparation" }
  